"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccOffsetBoxDropCardStyle = (0, _react.useMemo)(() => {
    const ccSOffsetBoxDropCard = (0, _css.css)({
      opacity: 0,
      transform: 'scaleY(0)'
    });
    const ccSOffsetBoxDropCardClose = (0, _css.css)({
      display: 'flex',
      justifyContent: 'end',
      height: pxToRem(24)
    });
    return {
      ccSOffsetBoxDropCard,
      ccSOffsetBoxDropCardClose
    };
  }, [pxToRem]);
  return {
    'cc-OffsetBoxDropCard': ccOffsetBoxDropCardStyle.ccSOffsetBoxDropCard,
    'cc-OffsetBoxDropCard__close': ccOffsetBoxDropCardStyle.ccSOffsetBoxDropCardClose
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;